/**
 * Runs asynchronous work with a fixed upper bound. A shared cursor keeps the
 * implementation small while preserving deterministic input order for task
 * assignment. Individual task errors are intentionally propagated.
 */
export const runWithConcurrency = async <T>(
  items: readonly T[],
  concurrency: number,
  task: (item: T, index: number) => Promise<void>
): Promise<void> => {
  if (items.length === 0) return;
  const workerCount = Math.min(items.length, Math.max(1, Math.floor(concurrency) || 1));
  let cursor = 0;
  const worker = async () => {
    while (cursor < items.length) {
      const index = cursor;
      cursor += 1;
      await task(items[index], index);
    }
  };
  await Promise.all(Array.from({ length: workerCount }, worker));
};

export default runWithConcurrency;
